import React from 'react';
import { useParams } from 'react-router';
import { useFetchSubmission } from '@common/features/submission/hooks/useFetchSubmission';
import useAppNavigation from '../../routing/useAppNavigation';
import { CustomerAllowedTaskActions, DocumentType } from '@common/types';
import { DocumentDetailsParentContent } from '@common/features/document/pages/ContentDetails/DocumentDetailsParentContent';
import { DocumentDetailsReadonlySection } from '@common/features/document/components/DocumentContentDetails/types';
import { useFetchSubmissionTaskData } from '@common/hooks/useFetchSubmissionTaskData';
import DocumentDetailsSkeletonLoader from '@common/features/document/pages/ContentDetails/DocumentDetailsSkeletonLoader';
import { getDocumentProccessingDetails } from '@common/features/document/helpers';
import { SubmissionTaskStatuses } from '@common/services/types';
import { ContentDetailsMode } from './types';

interface ISubmissionTaskContentDetails {
  contentType: DocumentType;
  printUrl: string;
  mode?: ContentDetailsMode;
}

export const SubmissionTaskContentDetails = ({ contentType, printUrl, mode }: ISubmissionTaskContentDetails) => {
  const { submissionId = '', documentId = '', taskId = '' } = useParams();
  const { submission, isFetchingSubmission, isSubmissionFetched } = useFetchSubmission(submissionId!);
  const { submissionTask } = useFetchSubmissionTaskData(taskId);

  const { goToSubmissionTaskDetails } = useAppNavigation();

  const redirectToSubmissionTaskDetails = () => {
    goToSubmissionTaskDetails(submissionId, taskId);
  };

  const documentProcessingDetails = getDocumentProccessingDetails(submissionTask);
  const isEditable = submissionTask?.allowedCustomerActions.includes(CustomerAllowedTaskActions.CustomerCanEditTaskDetails);
  const isHasDigitalSectionEditable = isEditable && submissionTask?.status !== SubmissionTaskStatuses.WithClientMoreInformation;

  const taskDocumentDetailsReadonlySections = {
    [DocumentDetailsReadonlySection.documentTitle]: !isEditable,
    [DocumentDetailsReadonlySection.hasDigitalVersion]: !isHasDigitalSectionEditable,
    [DocumentDetailsReadonlySection.isAccessiblePilRequested]: mode === ContentDetailsMode.Update,
  };

  if (isFetchingSubmission || !isSubmissionFetched) {
    return <DocumentDetailsSkeletonLoader />;
  }
  return (
    <DocumentDetailsParentContent
      isEditable={isEditable}
      isFormExtended={isEditable ?? false}
      documentDetailsReadonlySections={taskDocumentDetailsReadonlySections}
      submission={submission!}
      submissionId={submissionId!}
      documentId={documentId!}
      contentType={contentType}
      isAdmin={false}
      printUrl={printUrl}
      documentProcessingDetails={documentProcessingDetails}
      onCancel={redirectToSubmissionTaskDetails}
      onSuccess={redirectToSubmissionTaskDetails}
    />
  );
};
